export default __webpack_public_path__ + "static/media/2015_Ke_and_Miki_2015_FrontiersMicrobiology.2f600a19.pdf";